import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastContainer } from './components/shared/UI';
import { RequireAuth } from './components/shared/RequireAuth';

// Layouts
import AdminLayout  from './components/admin/AdminLayout';
import ClientLayout from './components/client/ClientLayout';

// Pages
import Login      from './pages/Login';
import PublicStore from './pages/PublicStore';

// Admin pages
import AdminDashboard from './pages/admin/Dashboard';
import AdminClients   from './pages/admin/Clients';
import AdminTemplate  from './pages/admin/Template';
import AdminSettings  from './pages/admin/Settings';

// Client pages
import ClientDashboard from './pages/client/Dashboard';
import ClientProducts  from './pages/client/Products';
import ClientConfig    from './pages/client/Config';

export default function App() {
  return (
    <AuthProvider>
      <ToastContainer />
      <BrowserRouter>
        <Routes>

          {/* ── Pública ─────────────────────────────────────────────────── */}
          <Route path="/login"             element={<Login />} />
          {/* /tienda/:clientId — usa el clientId del PHP (UUID) */}
          <Route path="/tienda/:clientId"  element={<PublicStore />} />
          <Route path="/"                  element={<Navigate to="/login" replace />} />

          {/* ── Super Admin ──────────────────────────────────────────────── */}
          <Route
            path="/admin"
            element={
              <RequireAuth role="superadmin">
                <AdminLayout />
              </RequireAuth>
            }
          >
            <Route index                element={<AdminDashboard />} />
            <Route path="clients"       element={<AdminClients />} />
            <Route path="template"      element={<AdminTemplate />} />
            <Route path="settings"      element={<AdminSettings />} />
          </Route>

          {/* ── Cliente ──────────────────────────────────────────────────── */}
          <Route
            path="/dashboard"
            element={
              <RequireAuth role="client">
                <ClientLayout />
              </RequireAuth>
            }
          >
            <Route index                element={<ClientDashboard />} />
            <Route path="productos"     element={<ClientProducts />} />
            <Route path="config"        element={<ClientConfig />} />
          </Route>

          {/* ── Fallback ─────────────────────────────────────────────────── */}
          <Route path="*" element={<Navigate to="/login" replace />} />

        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
